import React, { useEffect, useState } from "react";
import Filter from "../hallOfFame/header/Filter";
import styled from "styled-components";
import axios from "axios";
import { config as axiosConfig } from "../shared/config";
import style from "../shared/skeleton.module.css";

const BotDashboard = ({ openDetailedStat }) => {
  const filter = [
    {
      label: "HAP Delivery Lead ",
      filter: "engagementLead",
    },
    {
      label: "Functional HAP SMEs",
      filter: "functionalHAPSMEs",
    },
    {
      label: "Technology",
      filter: "technology",
    },
    {
      label: "Status",
      filter: "status",
    },
    {
      label: "Platform",
      filter: "platform",
    },
  ];

  const [activeFilter, setActiveFilter] = useState(0);

  const handleActiveFilter = (filter) => {
    ``;
    setActiveFilter(filter);
  };

  const [dates, setDates] = useState({
    fromDate: "",
    toDate: "",
  });

  const handleDateChange = (e) => {
    console.log("handleDateChange", e.target.name, e.target.value);
    setDates({ ...dates, [e.target.name]: e.target.value });
  };

  const [botDashboardData, setBotDashboardData] = useState([]);
  const [technologyTreeData, setTechnologyTreeData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getBotDasboardData = async () => {
    let auth;

    if (typeof window !== "undefined") {
      auth = JSON.parse(localStorage.getItem("auth")).data;
    }

    const config = {
      headers: {
        Authorization: auth?.accessToken,
      },
    };

    setLoading(true);

    try {
      const res = await axios.get(
        `${axiosConfig.baseUrl}/bot/dashboard?filter=${filter[activeFilter].filter}&dateFrom=${dates.fromDate}&dateTo=${dates.toDate}`,
        config,
      );
      if (res.data?.status === "success") {
        setBotDashboardData(res.data?.data);
      }
    } catch (error) {
      console.log("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBotDasboardData();
  }, [activeFilter, dates]);

  function transformTechnologyData(data) {
    const result = [
      {
        title: "RPA + ACS",
        children: [],
      },
      {
        title: "ACS",
        children: [],
      },
      {
        title: "RPA",
        children: [],
      },
    ];

    data.forEach((item) => {
      const technology = item.technology?.trim();

      // Skip Total Bots if you don't want it
      if (technology === "Total Bots") return;

      if (technology === "RPA") {
        // Only RPA
        result[2].children.push(item);
      } else if (technology?.includes("RPA,")) {
        // RPA + Something
        result[0].children.push(item);
      } else {
        // Everything else
        result[1].children.push(item);
      }
    });

    return result;
  }

  useEffect(() => {
    if (activeFilter === 2 && botDashboardData.length > 0) {
      setTechnologyTreeData(transformTechnologyData(botDashboardData));
    }
  }, [activeFilter, botDashboardData]);

  return (
    <div
      className={`${
        openDetailedStat ? "w-[90%]" : "w-0"
      } transition-all absolute left-[50%] top-12 bg-white min-h-[100px] max-h-[70vh] overflow-y-auto shadow-md z-20 translate-x-[-50%]`}
    >
      <div className="text-center py-3 bg-[#1F36C7] font-unilever-shilling-medium text-white">
        Detailed Bot Stats
      </div>
      {/* Filters & Date Range */}
      <div className="flex flex-col gap-5 xl:gap-0 xl:flex-row xl:items-center justify-between px-3 py-3 bg-[#e9ebf9]">
        <div className="flex items-center gap-4">
          {filter.map((f, index) => (
            <div
              onClick={() => handleActiveFilter(index)}
              key={f.filter}
              className={` ${index === activeFilter ? "bg-[#1F36C7] text-[#fff]" : "bg-[#d5d9f4] text-[#1F36C7] hover:bg-[rgba(31,54,199,0.2)]"} !border-[1px] !border-[rgba(31,54,199,0.1)] px-4 py-2 rounded-full cursor-pointer  uppercase font-unilever-shilling-medium text-[12px] `}
            >
              {f.label}
            </div>
          ))}
        </div>
        <div className="flex items-center gap-4">
          <span>
            From:{" "}
            <InputDate
              type="date"
              name="fromDate"
              value={dates.fromDate}
              onChange={handleDateChange}
            />
          </span>
          <span>
            To:{" "}
            <InputDate
              type="date"
              name="toDate"
              value={dates.toDate}
              onChange={handleDateChange}
            />
          </span>
        </div>
      </div>
      {/* Bots Data */}
      {botDashboardData?.[0]?.count === 0 ? (
        <p className="h-48 flex justify-center items-center">
          No bots found! Try changing filters or date range.
        </p>
      ) : (
        <>
          {filter[activeFilter].filter === "technology" ? (
            <div className="flex gap-24 p-4 h-[70vh]">
              {technologyTreeData.map((column, index) => (
                <div className="rounded-md h-[100px] md:w-[25%] xl:w-[20%] bg-[#1F36C7] p-3 text-white text-[17px] flex flex-col justify-between relative">
                  <span> {column.title}</span>
                  <span>
                    {column.children.reduce((acc, item) => acc + item.count, 0)}
                  </span>
                  <div className="absolute top-[103px] flex flex-col gap-5 pt-[42px] pl-16 bg-transparent rounded-none">
                    <div className="absolute h-full w-[2px] bg-[#1F36C7] rounded-b-2xl left-0 top-[-3px] rounded-t-full"></div>
                    {column.children.map((item, index) => (
                      <div
                        key={index}
                        className="bg-[#e9ebf9] text-[#1F36C7] p-3 rounded-md relative text-sm flex flex-col gap-3"
                      >
                        <span>{item?.technology}</span>
                        <span className="text-xs">{item?.count}</span>
                        <div className="absolute top-[50%] translate-y-[-50%] left-[-62px] w-[62px] h-[2px] bg-[#1F36C7] rounded-r-2xl"></div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 p-4">
              {loading ? (
                <>
                  {Array.from({ length: 12 }).map((_, index) => (
                    <div
                      key={index}
                      className={`h-[120px] ${style.skeleton_box} rounded-md`}
                    ></div>
                  ))}
                </>
              ) : (
                botDashboardData?.map((bot, i) => (
                  <div
                    key={i}
                    className={` ${i === 0 ? "bg-[#1F36C7]" : "bg-[#e9ebf9]"} rounded-md h-[120px] p-3 flex flex-col justify-between`}
                  >
                    <span
                      className={`${i === 0 ? "text-[#fff] text-[15px]" : "text-[#1F36C7] text-[13px]"} font-unilever-shilling-medium`}
                    >
                      {bot?.[filter[activeFilter].filter]}
                    </span>
                    <span
                      className={`${i === 0 ? "text-[#fff]" : "text-[#1F36C7]"} text-[30px] font-unilever-shilling-normal`}
                    >
                      {bot?.count}
                    </span>
                  </div>
                ))
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};

const InputDate = styled.input`
  background-color: #ffffff;
  color: #000;
  &::-webkit-calendar-picker-indicator {
    background-image: url("/hof_date.svg");
    cursor: pointer;
    scale: 1.5;
    position: relative;
    left: -8px;
  }
  padding: 5px 0;
  border-radius: 20px;
  padding-left: 5px;
  outline: none;
  border: none;
  text-transform: lowercase;
`;

export default BotDashboard;

